const mybrand = [
  {
    image:
      "https://static.wixstatic.com/media/5ea728_55e7c3a1850147a8b5d1985f4f3cd625~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_55e7c3a1850147a8b5d1985f4f3cd625~mv2.webp",
    link: "https://ajusa.online/en/",
    title: "ajusa",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_0b873a000ba742b8a1074b5f55729b73~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_0b873a000ba742b8a1074b5f55729b73~mv2.webp",
    link: "https://www.coopersfiaam.com/en/catalogue/online-catalogue.html",
    title: "coopersfiaam",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_046d851c29ba413facca5b9c11d8b68b~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_046d851c29ba413facca5b9c11d8b68b~mv2.webp",
    link: "https://www.dayco.com/en/",
    title: "dayco",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_c0fc7e71dcf84aa2aebc97444190f3da~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_c0fc7e71dcf84aa2aebc97444190f3da~mv2.webp",
    link: "https://www.fram.com/",
    title: "fram",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_3be79a63876e4ccba15965855d7a6fdf~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_3be79a63876e4ccba15965855d7a6fdf~mv2.webp",
    link: "https://www.comline.uk.com/",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_4439075102d94b6ba2fae9bdd7d55865~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_4439075102d94b6ba2fae9bdd7d55865~mv2.webp",
    link: "https://www.efiautomotive.com/",
    title: "efi",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_4031997473034c74a525a6f8f0217205~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_4031997473034c74a525a6f8f0217205~mv2.webp",
    link: "https://www.durand-production.com/",
    title: "durand",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_7558a5b6b21e46078724d381eb5a4d67~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_7558a5b6b21e46078724d381eb5a4d67~mv2.webp",
    link: "https://www.fare-auto.com/es/",
    title: "fare",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_a79ab5914a774dff9733cc695bffa2f7~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_a79ab5914a774dff9733cc695bffa2f7~mv2.webp",
    link: "https://www.icerbrakes.com/",
    title: "icer",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_e8c357f3ec6345878b177920135c3e00~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_e8c357f3ec6345878b177920135c3e00~mv2.webp",
    link: "https://www.gmb.jp/en/",
    title: "gmb",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_4a4a7b9a6e2b49ebaebf575265c24528~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_4a4a7b9a6e2b49ebaebf575265c24528~mv2.webp",
    link: "https://www.kavoparts.com/",
    title: "kavo",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_63377e60b165446eb3930afae95b5af9~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_63377e60b165446eb3930afae95b5af9~mv2.webp",
    link: "https://www.kawe.nl/fr/assortiment/voiture-et-van/produits/",
    title: "kawe",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_935ea36cad5a4d15b87e671cbec73e88~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_935ea36cad5a4d15b87e671cbec73e88~mv2.webp",
    link: "https://kybme.com/",
    title: "kyb",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_b3f729294e574daa92c355e59e0fa4f0~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_b3f729294e574daa92c355e59e0fa4f0~mv2.webp",
    link: "https://lucasdiesel.com/",
    title: "lucas",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_927a982dbaf64438a3ecba7ae9e2e534~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_927a982dbaf64438a3ecba7ae9e2e534~mv2.webp",
    link: "https://www.mecafilter.com/",
    title: "mecafilter",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_fff919491ae24641a25b08110d3fe1d3~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_fff919491ae24641a25b08110d3fe1d3~mv2.webp",
    link: "https://misfat.com.tn/",
    title: "misfat",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_036d71766a4f4c4e8fb5064e522b6979~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_036d71766a4f4c4e8fb5064e522b6979~mv2.webp",
    link: "https://www.movendisgroup.com/",
    title: "movendis",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_e1d85acf03054efcbb2ececb1742acd2~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_e1d85acf03054efcbb2ececb1742acd2~mv2.webp",
    link: "https://ocap.it/index.php/en/",
    title: "ocap",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_8cd548ef35f945dba57fc85d23bf9e5a~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_8cd548ef35f945dba57fc85d23bf9e5a~mv2.webp",
    link: "https://www.optibelt.com/fr/accueil/",
    title: "optibelt",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_bb8f8f2eff0f44398d98134de150533c~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_bb8f8f2eff0f44398d98134de150533c~mv2.webp",
    link: "https://www.purflux.com/fr/index.html",
    title: "purflux",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_b1b04d7fce434929949f30825dcad7d4~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_b1b04d7fce434929949f30825dcad7d4~mv2.webp",
    link: "https://www.remante.com/",
    title: "remante",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_17d7cc2ed1cd48029e84b1c9de083403~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_17d7cc2ed1cd48029e84b1c9de083403~mv2.webp",
    link: "https://www.saleri.com/",
    title: "saleri",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_393bafe0bfb443eba5f0f7707abb6949~mv2.jpg/v1/fill/w_374,h_374,q_90/5ea728_393bafe0bfb443eba5f0f7707abb6949~mv2.webp",
    link: "https://www.sia-am.com/",
    title: "sia",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_5a5d6a3b34d04bd8b84d2fad217d8a68~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_5a5d6a3b34d04bd8b84d2fad217d8a68~mv2.webp",
    link: "https://www.sidem.be/",
    title: "sidem",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_532c96c85c114a7ebe3a5571840b8135~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_532c96c85c114a7ebe3a5571840b8135~mv2.webp",
    link: "https://www.sogefipro.com/en/index.html",
    title: "sogefipro",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_6623690cfdff4aa3b0101bc7558d00b6~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_6623690cfdff4aa3b0101bc7558d00b6~mv2.webp",
    link: "https://www.svac.com.tr/",
    title: "svac",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_a193b90beffc4953a84577d49641024b~mv2.png/v1/fill/w_374,h_374,q_90/5ea728_a193b90beffc4953a84577d49641024b~mv2.webp",
    link: "https://wonheurope.com/",
    title: "wonh",
  },
  {
    image:
      "https://static.wixstatic.com/media/5ea728_b6fbb54ed74c401b92457d6fd9119129~mv2.png/v1/fill/w_376,h_374,q_90/5ea728_b6fbb54ed74c401b92457d6fd9119129~mv2.webp",
    link: "https://www.yuasa.co.uk/",
    title: "yuasa",
  },
];
export default mybrand;
